import "./h3TitleStyle.css"

export default function H3Title({title, color='black'}) {
    return (
        <h3 
            className="sub-title-h3"
            style={ {color: color} }
        >
            {title}
        </h3>
    );
}